import { getQueryParam } from './../utils/jumpQuery';
import type { LocaleCode } from '@/i18n/localeStore';
import Cookies from 'js-cookie';

export type Language = 'en' | 'zh-Hans' | 'zh-Hant' | 'pt' | 'es' | 'id' | 'de' | 'th';

const resolveLanguage = (
  language: string,
  defaultLanguage: Language,
  supportLanguages?: Language[]
): Language => {
  const resolved = language as Language;
  if (!supportLanguages || supportLanguages.includes(resolved)) {
    return resolved;
  }
  return defaultLanguage;
};

/**
 * 获取语言：优先读取 URL query 的 language，否则读取 Cookie DESIGN_CLIENT_LANGUAGE
 * @param defaultLanguage 默认语言，默认 'zh-Hans'
 * @param supportLanguages 支持的语言数组，默认不限制
 * @returns 语言
 */
export const getLanguage = (
  defaultLanguage: Language = 'zh-Hans',
  supportLanguages?: Language[]
): Language => {
  const queryLanguage = getQueryParam('language');
  if (queryLanguage) {
    return resolveLanguage(queryLanguage, defaultLanguage, supportLanguages);
  }

  const cookieLanguage = Cookies.get('DESIGN_CLIENT_LANGUAGE');
  if (cookieLanguage) {
    return resolveLanguage(cookieLanguage, defaultLanguage, supportLanguages);
  }

  return defaultLanguage;
};

/**
 * 获取 Cookie 语言
 * @param defaultLanguage 默认语言，默认'zh-Hans'
 * @param supportLanguages 支持的语言 数组，默认['en', 'zh-Hans']
 * @returns 语言
 */
export const getCookieLanguage = (
  defaultLanguage: Language = 'zh-Hans',
  supportLanguages?: Language[]
) => {
  const language = (getQueryParam('language') ||
    Cookies.get('DESIGN_CLIENT_LANGUAGE') ||
    defaultLanguage) as Language;

  // 如果支持的语言为空，则返回当前语言 或者 支持的语言中存在当前语言
  if (!supportLanguages || supportLanguages.includes(language)) {
    return language;
  }
  // 如果支持的语言中没有当前语言，则返回默认语言
  return defaultLanguage;
};

export const DEFAULT_LOCALE: LocaleCode = (window.__LOCALE__ = getLanguage('zh-Hans'));
